//src/pages/AddPatientModal/editPatientModal.tsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import BasicModal from "../../components/BasicModal";
import FormModalActions from "../../components/FormModalActions";
import { LARGE_FORM_MODAL_SX } from "../../utils/formModalStyles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { updatePatient, getAllPatients, registerPatient } from "../../services/patientService";
import { create } from "../../services/PatientAdmissionService";
import { updatePortalUser } from "../../services/userManagementService";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name should be of minimum 2 characters length"),
  gender: Yup.string().required("Gender is required"),
  // dob: Yup.string().required("DOB is required"),
  dob: Yup.date()
      .required("DOB is required")
      .max(dayjs(), "DOB cannot be in the future"),
  address: Yup.string().required("Address is required"),
  //patientType: Yup.string().required("Patient type is required"),
  aadhar: Yup.string()
    .notRequired() // Make Aadhar optional
    .test('aadhar-format', 'Aadhar should be a 12-digit number', function(value) {
      if (!value || value.length === 0) return true; // Allow empty values
      return /^\d{12}$/.test(value);
    }),
  email: Yup.string()
    .email("Enter a valid email")
    // .required("Email is required"),
    .notRequired(), // Make email optional
  mobile: Yup.string()
    .notRequired() // Make contact number optional
    .test('mobile-format', 'Contact Number should be a 10-digit number', function(value) {
      if (!value || value.length === 0) return true; // Allow empty values
      return /^\d{10}$/.test(value);
    }),
});

const EditPatientModal = ({ open, onClose, admissionPatientName, admissionPatientContact, patient_info = {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [current_step, setCurrentStep] = useState({
    new_patient: true,
    create_invoice: false,
    success: false,
  });
  // allowDuplicateContact state removed - no longer needed

  // fetchExistingPatients function removed - no longer needed
  // checkForFieldDuplicates function removed - no longer needed

  // const formik = useFormik({
  //   initialValues: {
  //     name: patient_info?.["name"] || "",
  //     address: patient_info?.["address"] || "",
  //     aadhar: patient_info?.["aadhar"] || "",
  //     email: patient_info?.["email"] || "",
  //     dob: patient_info?.["dob"] ? dayjs(patient_info?.["dob"]) : null,
  //     mobile: patient_info?.["mobile"] || "",
  //     gender: patient_info?.["gender"] || "",
  //     patientType: patient_info?.["patientType"] || "",
  //   },
  //   enableReinitialize: true,
  //   validationSchema: validationSchema,
  //   onSubmit: async (values) => {
  //     // Check for duplicates
  //     const isDuplicate = await checkForDuplicates(values);
  //     if (isDuplicate) {
  //       toast.error("A patient with the same name, DOB, or Aadhar already exists.");
  //       return;
  //     }
  //     const patient_req_body = {
  //       name: values.name,
  //       mobile: values.mobile,
  //       email: values.email,
  //       aadhar: values.aadhar,
  //       address: values.address,
  //       dob: dayjs(values.dob).format("YYYY-MM-DD"),
  //       gender: values.gender,
  //       patientType: values.patientType,
  //     };
  //     try {
  //       if (patient_info?.["id"]) {
  //         patient_req_body["id"] = patient_info?.["id"];
  //         const hasChanged =
  //           patient_info?.["name"] !== patient_req_body.name ||
  //           patient_info?.["mobile"] !== patient_req_body.mobile ||
  //           patient_info?.["email"] !== patient_req_body.email ||
  //           patient_info?.["aadhar"] !== patient_req_body.aadhar ||
  //           patient_info?.["address"] !== patient_req_body.address ||
  //           patient_info?.["gender"] !== patient_req_body.gender ||
  //           dayjs(patient_info?.["dob"]).format("YYYY-MM-DD") !== patient_req_body.dob ||
  //           patient_info?.["patientType"] !== patient_req_body.patientType;
  //         if (hasChanged) {
  //           await updatePatient(patient_info?.["id"], patient_req_body);
  //           toast.success("Patient updated successfully!");
  //           onClose();
  //         } else {
  //           console.log("No changes detected.");
  //         }
  //       } else {
  //         alert("No patient found!");
  //       }
  //     } catch (error) {
  //       toast.error("Something went wrong!");
  //       console.error(error);
  //     }
  //   },
  // });
  const formik = useFormik({
    initialValues: {
      name: patient_info?.name || admissionPatientName || "",
      address: patient_info?.address || "",
      aadhar: patient_info?.aadhar || "",
      email: patient_info?.email || "",
      dob: patient_info?.dob ? dayjs(patient_info.dob) : null,
      mobile: patient_info?.mobile || admissionPatientContact || "",
      gender: patient_info?.gender || "",
      //patientType: patient_info?.patientType || "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Skip all duplicate validation
      console.log("Skipping all duplicate validation in edit modal");
      const patient_req_body = {
        name: values.name,
        mobile: values.mobile || null,
        email: values.email || null,
        aadhar: values.aadhar || null,
        address: values.address,
        dob: dayjs(values.dob).format("YYYY-MM-DD"),
        gender: values.gender,
        patientType: values.patientType,
      };

      try {
        if (patient_info?.id) {
          patient_req_body.id = patient_info.id;

          const hasChanged =
            patient_info.name !== patient_req_body.name ||
            patient_info.mobile !== patient_req_body.mobile ||
            patient_info.email !== patient_req_body.email ||
            patient_info.aadhar !== patient_req_body.aadhar ||
            patient_info.address !== patient_req_body.address ||
            patient_info.gender !== patient_req_body.gender ||
            dayjs(patient_info.dob).format("YYYY-MM-DD") !== patient_req_body.dob ||
            patient_info.patientType !== patient_req_body.patientType;

          // Check if common fields (name, mobile, email) have changed
          const hasCommonFieldsChanged =
            patient_info.name !== patient_req_body.name ||
            patient_info.mobile !== patient_req_body.mobile ||
            patient_info.email !== patient_req_body.email;

          if (hasChanged) {
            // Update patient table (multi-tenant aware)
            try {
              await updatePatient(patient_info.id, patient_req_body);
            } catch (error: any) {
              const status = error?.response?.status;
              const message =
                error?.response?.data?.message ||
                (typeof error?.response?.data === "string"
                  ? error.response.data
                  : "");

              // If patient is not found in this organization, create an org-specific record instead
              if (
                status === 404 &&
                typeof message === "string" &&
                message.includes("Patient not found in organization")
              ) {
                try {
                  // Create patient in current organization's table WITHOUT creating a new portal user
                  const createdPatient = await registerPatient(patient_req_body, {
                    createUserAccount: false,
                  });

                  if (createdPatient?.portalCredentials) {
                    toast.success(
                      `Patient not found in this organization. A new patient record was created for this hospital with portal access. Temporary password: ${createdPatient.portalCredentials.password}`,
                      { autoClose: 6000 }
                    );
                  } else {
                    toast.success(
                      "Patient not found in this organization. A new patient record was created for this hospital."
                    );
                  }

                  onClose();
                  return;
                } catch (createError) {
                  console.error(
                    "Failed to create organization-specific patient after 404:",
                    createError
                  );
                  throw createError;
                }
              }

              // Any other error: rethrow to outer catch
              throw error;
            }

            // Update user table if common fields changed and patient has a userId
            if (hasCommonFieldsChanged && patient_info.userId) {
              try {
                const userUpdatePayload = {
                  id: patient_info.userId,
                  full_name: values.name,
                  user_role: "patient",
                  email: values.email || "",
                  department: "",
                  mobile: values.mobile || "",
                };

                await updatePortalUser(userUpdatePayload);
              } catch (userUpdateError) {
                console.error("Error updating user table:", userUpdateError);
                // Don't block the flow if user update fails, but show a warning
                toast.warning("Patient updated successfully, but user table update failed. Please try updating again.");
              }
            }

            toast.success("Patient updated successfully!");
            onClose();
          } else {
            toast.info("No changes detected.");
          }
        } else {
          const patient_req_body_new = {
            name: admissionPatientName,
            mobile: admissionPatientContact || null,
            email: values.email || null,
            aadhar: values.aadhar || null,
            address: values.address,
            dob: dayjs(values.dob).format("YYYY-MM-DD"),
            gender: values.gender,
            patientType: values.patientType,
          };
          const createdPatient = await registerPatient(patient_req_body_new);
          if (createdPatient?.portalCredentials) {
            toast.success(
              `Patient portal created. Temporary password: ${createdPatient.portalCredentials.password}`,
              { autoClose: 6000 }
            );
          } else {
            toast.success("Patient created successfully!");
          }
          onClose();
        }
      } catch (error) {
        console.error("Error in EditPatientModal onSubmit:", error);

        const status = (error as any)?.response?.status;
        const message =
          (error as any)?.response?.data?.message ||
          (typeof (error as any)?.response?.data === "string"
            ? (error as any).response.data
            : "");

        // Fallback handling for multi-tenant 404: patient not found in this organization
        // Some backends may return a different message, so treat ANY 404 on PUT as "not in this org"
        if (status === 404) {
          try {
            const createdPatient = await registerPatient(patient_req_body, {
              createUserAccount: false,
            });

            if (createdPatient?.id) {
              toast.success(
                "Patient was not present in this organization. A new patient record was created for this hospital."
              );
              onClose();
            } else {
              toast.error(
                "Patient not found in this organization and creating a new record failed."
              );
            }
          } catch (createError) {
            console.error(
              "Fallback org-specific patient creation failed:",
              createError
            );
            toast.error(
              "Something went wrong while creating patient for this organization."
            );
          }
        } else {
          toast.error("Something went wrong!");
        }
      }
    },
  });
  
  const handelCloseModalState = async () => {
    // Don't navigate at all - just close the modal to preserve current page state
    // Navigation was causing tab switching issues on pages with tab management
    // Removed all navigate() calls to prevent unwanted redirects
    
    await onClose();
    formik.resetForm();
    setCurrentStep({
      new_patient: true,
      create_invoice: false,
      success: false,
    });
  };

  const modalTitle = !!patient_info?.["id"] ? "Update Patient" : "Create Patient";

  return (
    <BasicModal
      open={open}
      onClose={handelCloseModalState}
      sx={LARGE_FORM_MODAL_SX}
      title={modalTitle}
    >
      <Box display="flex" flexDirection="column">
        {current_step.new_patient && (
          <>
            <Box>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  formik.handleSubmit();
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="name"
                      name="name"
                      label="Name"
                      value={formik.values.name}
                      onChange={(e) => {
                        let inputValue = e.target.value;
                        
                        // Capitalize first letter
                        if (inputValue.length > 0) {
                          inputValue = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                        }
                        
                        formik.setFieldValue("name", inputValue);
                      }}
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="gender"
                      name="gender"
                      fullWidth
                      select
                      label="Gender"
                      value={formik.values.gender}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.gender && Boolean(formik.errors.gender)
                      }
                    >
                      {["Male", "Female"].map((gender) => (
                        <MenuItem key={gender} value={gender}>
                          {gender}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="DOB"
                        format="YYYY-MM-DD"
                        value={formik.values.dob}
                        onChange={(value) =>
                          formik.setFieldValue("dob", value)
                        }
                        maxDate={dayjs()} // Disable future dates
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.dob && Boolean(formik.errors.dob),
                            helperText:
                              formik.touched.dob && formik.errors.dob,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="aadhar"
                      name="aadhar"
                      label="Aadhar"
                      value={formik.values.aadhar}
                      onChange={(e) => {
                        // Only allow digits and limit to 12 digits
                        const value = e.target.value.replace(/\D/g, '').slice(0, 12);
                        formik.setFieldValue("aadhar", value);
                      }}
                      inputProps={{ maxLength: 12 }}
                      error={
                        formik.touched.aadhar &&
                        Boolean(formik.errors.aadhar)
                      }
                      helperText={
                        formik.touched.aadhar && formik.errors.aadhar
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      label="Email"
                      value={formik.values.email}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow email characters including @ symbol (letters, numbers, dots, hyphens, underscores, @, and +)
                        if (value === "" || /^[a-zA-Z0-9._+-@]*$/.test(value)) {
                          formik.setFieldValue("email", value);
                        }
                      }}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={
                        formik.touched.email && formik.errors.email
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="mobile"
                      name="mobile"
                      label="Contact Number"
                      value={formik.values.mobile}
                      onChange={(e) => {
                        // Only allow digits and limit to 10 digits
                        const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        formik.setFieldValue("mobile", value);
                      }}
                      inputProps={{ maxLength: 10 }}
                      error={
                        formik.touched.mobile && Boolean(formik.errors.mobile)
                      }
                      helperText={
                        formik.touched.mobile && formik.errors.mobile
                      }
                    />
                  </Grid>
                  {/* Allow duplicate contact checkbox removed - no longer needed */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="address"
                      name="address"
                      label="Address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.address &&
                        Boolean(formik.errors.address)
                      }
                      helperText={
                        formik.touched.address && formik.errors.address
                      }
                    />
                  </Grid>
                  {/* <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="patientType"
                      name="patientType"
                      label="Patient Type"
                      value={formik.values.patientType}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid> */}

                  {/* <Grid item xs={6}>
                      <TextField
                      fullWidth
                      id="patientType"
                      name="patientType"
                      label="Patient Type"
                      value={formik.values.patientType}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid> */}

                  <Grid item xs={12}>
                    <FormModalActions
                      onCancel={handelCloseModalState}
                      submitType="submit"
                      loading={formik.isSubmitting}
                    />
                  </Grid>
                </Grid>
              </form>
            </Box>
          </>
        )}
      </Box>
    </BasicModal>
  );
};

export default EditPatientModal;